module.exports = __webpack_public_path__ + "img/app-store.cd0bfeb.webp?v=1763107891460";